export default __webpack_public_path__ + "static/media/HomeGrid2.1461ad7c.jpg";